/**
 * @internal
 */
import React from 'react';
import { domMax, LazyMotion, MotionConfig } from 'framer-motion';
import isPropValid from '@emotion/is-prop-valid';
export const MotionProvider = ({ children }) => (
// This is required to force the right function is used to determine if a property is valid to be propagated on the DOM.
// Previously teams had issues because React was providing a warning (in red, like an error) that a property was propagated which was not valid.
React.createElement(MotionConfig, { isValidProp: isPropValid },
    React.createElement(LazyMotion, { features: domMax }, children)));
